import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-step-confirm-popup',
  templateUrl: './step-confirm-popup.component.html',
  styleUrls: ['./step-confirm-popup.component.css']
})
export class StepConfirmPopupComponent implements OnInit {
  massage: string;
  paramOne: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/step-confirm-popup/step-confirm-popup.component.ts